const ACTIVE_BTN_CLASSES = ["bg-ribbon-primary", "text-ribbon-primary-foreground", "shadow-sm"];
const INACTIVE_BTN_CLASSES = [
  "bg-ribbon-background/60",
  "text-ribbon-muted-foreground",
  "hover:bg-ribbon-background",
  "hover:text-ribbon-foreground",
];

export function initRewardsCatalogueFilter() {
  const root = document.querySelector<HTMLElement>("[data-rewards-filter]");
  if (!root) {
    return;
  }

  const cards = Array.from(document.querySelectorAll<HTMLElement>("[data-rewards-card]"));
  const buttons = Array.from(document.querySelectorAll<HTMLButtonElement>(".rewards-cat-btn"));
  const categorySelect = document.querySelector<HTMLSelectElement>("[data-rewards-category-select]");
  const search = document.querySelector<HTMLInputElement>("[data-rewards-search]");
  const empty = document.querySelector<HTMLElement>("[data-rewards-empty]");
  const count = document.querySelector<HTMLElement>("[data-rewards-count]");

  let activeCategory = "all";
  let activeQuery = "";

  const setActiveButton = (target: HTMLButtonElement | undefined) => {
    buttons.forEach((btn) => {
      const isActive = btn === target;
      ACTIVE_BTN_CLASSES.forEach((c) => btn.classList.toggle(c, isActive));
      INACTIVE_BTN_CLASSES.forEach((c) => btn.classList.toggle(c, !isActive));
    });
  };

  const apply = () => {
    let visible = 0;
    cards.forEach((card) => {
      const cat = card.dataset.category || "";
      const name = card.dataset.name || "";
      const matchesCat = activeCategory === "all" || cat === activeCategory;
      const matchesQuery = !activeQuery || name.includes(activeQuery);
      const show = matchesCat && matchesQuery;
      card.classList.toggle("hidden", !show);
      if (show) {
        visible++;
      }
    });
    if (empty) {
      empty.classList.toggle("hidden", visible > 0);
    }
    if (count) {
      count.textContent = `${visible} ${visible === 1 ? "brand" : "brands"}`;
    }
  };

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      activeCategory = btn.dataset.rewardsCategory || "all";
      setActiveButton(btn);
      if (categorySelect) {
        categorySelect.value = activeCategory;
      }
      apply();
    });
  });

  if (categorySelect) {
    categorySelect.addEventListener("change", () => {
      activeCategory = categorySelect.value;
      setActiveButton(buttons.find((btn) => btn.dataset.rewardsCategory === activeCategory));
      apply();
    });
  }

  if (search) {
    search.addEventListener("input", () => {
      activeQuery = search.value.trim().toLowerCase();
      apply();
    });
  }

  apply();
}
